import * as React from 'react';
import Grid from "@mui/material/Grid";
import {useNavigate} from "react-router-dom";
import {useState} from "react";
import useRootHook from "../../hooks/useRoot";
import referrals from "../../models/referrals";
import helpers from "../../helpers/common";
import ReferralForm from "./ReferralForm";
import PageHeader from '../layout/PageHeader';
import SectionCard from '../layout/SectionCard';

export default function ReferralAdd(props) {
    const {setShowLoader} = useRootHook()
    const navigate = useNavigate()
    const [errors, setErrors] = useState({});
    const [fields, setFields] = useState({
        username: '',
        password: '',
        name: '',
        enabled: false,
        merchants: []
    })

    const handleChange = (ev) => {
        const [target, value, name] = helpers.getFormEventData(ev);

        setErrors({...errors, [name]: undefined});

        setFields((prevState) => {
            let newFields = {...prevState};
            newFields[name] = value;

            return newFields
        })
    }

    const handleBlur = (ev) => {
        const [target, value, name] = helpers.getFormEventData(ev)

        const newErrors = {...errors}
        const newFields = {...fields}

        typeof referrals.fieldValidator[name] === 'function'
        && referrals.fieldValidator[name](newFields, newErrors)

        setErrors(newErrors)
    }

    const handleSubmit = (ev) => {
        ev.preventDefault()
        const validationErrors = referrals.methodValidator.add(fields)
        setErrors(validationErrors)

        if (Object.keys(validationErrors).length !== 0) return

        setShowLoader(true)
        referrals.add(fields)
            .then(() => {
                setShowLoader(false)
                navigate('/referrals')
            }).catch(() => setShowLoader(false))
    }

    return <React.Fragment>
        <Grid size={12}>
            <PageHeader title="Add referral" breadcrumbs={[['Dashboard', '/'], ['Referrals', '/referrals'], ['Add', '/referrals/add']]} />
        </Grid>
        <Grid size={12}>
            <SectionCard sx={{ display: 'flex', flexDirection: 'column' }}>
                <ReferralForm fields={fields} errors={errors} handleChange={handleChange}
                              handleBlur={handleBlur} handleSubmit={handleSubmit} />
            </SectionCard>
        </Grid>
    </React.Fragment>
}

